import StoryCard from "./StoryCard.js";

import { Box, Typography } from "@mui/material";
import "@emotion/react";
import "@emotion/styled";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import { timelineOppositeContentClasses } from "@mui/lab/TimelineOppositeContent";

const timeLineContent = [
  {
    time: "2022-2023",
    title: "Sixth form Python project / MyTourMaker",
    content:
      "Between 2021 and 2023, I studied A-Level Computer Science in Sixth Form. Our coursework provided freedom in terms of topic selection, whilst teachers gave us no guidance on how to develop software projects. I used this opportunity to learn Python, PyQt5 framework + other Python libraries, JavaScript (including Leaflet). I also gained experience of integrating different APIs in my project such as Mapbox, OpenStreetMap, OpenRouteService.",
    id: "24b69a15-8198-4ab0-a8aa-db591ab708a2",
  },
  {
    time: "August 2023",
    title: "Accepted to university",
    content:
      "In August 2023, I've been accepted to the University of Bristol to study Computer Science.",
    id: "b1d1f61d-58b0-4c5b-927d-f05454a8cf92",
  },
  {
    time: "Winter-Spring of 2024",
    title: "University Java coursework (2024)",
    content:
      'As part of a pair-programming coursework, me and my teammate implemented Java-based backend for a 2D implementation of the "Scotland Yard" board game.  This project not only deepened my understanding of the Java language but also introduced me to key OOP principles and version control using Git.',
    id: "c1617f19-f882-4e05-9e56-30df63440e2e",
  },
  {
    time: "2024-2025",
    title: "AI Learning Tool",
    content:
      "In this university group project, we collaborated with a real-world client, John McNamara from IBM. Our task was to create an AI-powered chatbot web app designed to help users find courses on IBM SkillsBuild platform that would suit them the best and answer questions about university life frequently faced by first year students. This project significantly strengthened my skills in full-stack development (Vue JS 3 + Java + Spring Boot), CI/CD (using Docker and GitHub Actions), networking, cloud services and team-based Agile workflows.",
    id: "c1cb5aba-cd0b-4051-905c-fb01a29f9efd",
  },
  {
    time: "June 2025",
    title: "Teaching internship",
    content:
      "I have completed my internship at Odyssey Teaching School Hub. I assisted GCSE, BTEC, and A-Level Computing teachers during lessons; helped students to maintain productivity in the classroom; provided extracurricular guidance to high-achieving students; resolved technical issues with Windows OS, Python, and Adobe software; supported and supervised SEND students. This experience enhanced my resilience, communication skills and adaptability, teaching me how to maintain a supportive learning environment even in demanding situations.",
    id: "494094ab-6a82-4760-a2f0-39b146269569",
  },
];

export default function MyStory() {
  let timeLineCards = timeLineContent.map((timeLineEvent) => {
    return {
      src: timeLineEvent,
      card: (
        <StoryCard
          time={timeLineEvent["time"]}
          title={timeLineEvent["title"]}
          content={timeLineEvent["content"]}
          key={timeLineEvent["id"]}
        />
      ),
    };
  });

  let timeLineItems = timeLineCards.map((timeLineCard) => {
    return (
      <TimelineItem key={timeLineCard["src"]["id"]}>
        <TimelineOppositeContent color="textSecondary">
          {timeLineCard["src"]["time"]}
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot sx={{ bgcolor: "primary.main" }} />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>{timeLineCard["card"]}</TimelineContent>
      </TimelineItem>
    );
  });

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        my: 4,
      }}
    >
      <Typography variant="h3" sx={{ fontWeight: 800 }}>
        My story
      </Typography>
      <Timeline
        sx={{
          [`& .${timelineOppositeContentClasses.root}`]: {
            flex: 0.3,
          },
        }}
      >
        {timeLineItems}
      </Timeline>
    </Box>
  );
}
